'use strict'

import {
  Polymer
} from '@polymer/polymer/lib/legacy/polymer-fn.js'
import {
  dom
} from '@polymer/polymer/lib/legacy/polymer.dom.js'
import {
  html
} from '@polymer/polymer/lib/utils/html-tag.js'
import '@polymer/iron-collapse/iron-collapse'
import '@polymer/paper-tooltip/paper-tooltip'
Polymer({
  is: 'moskito-messenger',
  _template: html`
<style include="iron-flex iron-flex-alignment moskito-styles">
a {
  text-decoration: none;
  color: var(--default-primary-color);
}
.accent {
  color: var(--default-primary-color);
}
paper-card {
  width: 100%;
  margin-bottom: 12px;
}
.moskito-messenger-wrapper {
  align-items: center;
  min-width: 94px;
  max-width: 164px;
}
.messenger-name {
  text-align: center;
}
moskito-avatar.messenger-avatar {
  --paper-avatar-width: 28px;
  border: var(--default-secondary-color) solid 2px;
  margin-right: 12px;
}
div.card-actions {
display: flex;
justify-content: flex-end;
}
</style>
  <paper-card elevation="1" animated-shadow="false">
    <div class="card-content layout vertical">
        <h4 class="flex-2 v-spaced">
          {{_translate('Type your Message below:')}}
        </h4>
        <paper-textarea value={{message}} rows="5" char-counter maxlength="1000"></paper-textarea>
    </div>
    <div class="card-actions">
        <paper-button on-tap="_send"><iron-icon icon="icons:send"></iron-icon>{{_translate('Send')}}</paper-button>
    </div>
  </paper-card>
`,
  properties: {
    message: {
      type: String,
      notify: true
    }
  },
  isTranslation: function (title) {
    if (title.original.language === 'fr') {
      return false
    } else {
      return true
    }
  },
  _translate: function (string) {
    return window.__(string)
  },
  _send: function () {
    this.dispatchEvent(new CustomEvent('send', { detail: { message: this.message } }))
  }
})
